export function convertPersianToEnglish(persianNumber) {
  const persianToEnglishMap = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
  };

  if (persianNumber) {
    return persianNumber.replace(/[۰-۹]/g, function (match) {
      return persianToEnglishMap[match];
    });
  }
}
export function convertEnglishToPersian(englishNumber) {
  const englishToPersian = {
    0: '۰',
    1: '۱',
    2: '۲',
    3: '۳',
    4: '۴',
    5: '۵',
    6: '۶',
    7: '۷',
    8: '۸',
    9: '۹',
  };
  if (englishNumber) {
    return englishNumber?.replace(/[0-9]/g, function (match) {
      return englishToPersian[match];
    });
  }
}
export const addCommas = (e) => {
  const str = e?.toString();
  return str?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const removeNonNumeric = (e) => {
  const persianToEnglishMap = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
  };

  const str = e?.toString();

  const num = str
    .split('')
    .map((char) => persianToEnglishMap[char] || char)
    .join('');

  return num?.replace(/[^\d]/g, '');
};
